import React from 'react';
export function Container({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full max-w-content px-5 md:px-8 ${className}`} data-id="element-485" data-mp="2i6fh3exoyznn">{children}</div>;
}
export function Eyebrow({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}) {
  return <p className={`text-xs font-semibold uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-accent-400' : 'text-brand-600'}`} data-id="element-486" data-mp="2r4hsmof1xap6">
      {children}
    </p>;
}
type HeadingProps = {
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3';
  size?: 'xl' | 'lg' | 'md';
  tone?: 'light' | 'dark';
  className?: string;
};
const sizeMap = {
  xl: 'text-[2.6rem] leading-[1.02] md:text-6xl lg:text-[4.2rem]',
  lg: 'text-3xl leading-[1.06] md:text-5xl',
  md: 'text-2xl leading-[1.12] md:text-[2rem]'
};
export function Heading({
  children,
  as: Tag = 'h2',
  size = 'lg',
  tone = 'light',
  className = ''
}: HeadingProps) {
  return <Tag className={`font-display font-bold tracking-tightest ${sizeMap[size]} ${tone === 'dark' ? 'text-white' : 'text-graphite-900'} ${className}`} data-id="element-487" data-mp="24ljjlbhgop9w">
      {children}
    </Tag>;
}
export function Lead({
  children,
  tone = 'light',
  className = ''
}: {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}) {
  return <p className={`text-lg leading-relaxed ${tone === 'dark' ? 'text-mist-200' : 'text-graphite-500'} ${className}`} data-id="element-488" data-mp="2jc8xwmq7ykhz">
      {children}
    </p>;
}
export function SectionCounter({
  value
}: {
  value: string;
}) {
  return <span className="font-display text-sm font-bold tabular-nums text-accent-500" data-id="element-489" data-mp="2x9xh7q4n1jkx">{value}</span>;
}